/**
 * A function that sorts jobs in descending order by their creation date (metadata.created_at)
 * @param {Job[]} jobs
 */
export const sortJobs = (jobs) => {
  if (!jobs) return [];
  return jobs.sort(
    (job1, job2) => job2.metadata.created_at - job1.metadata.created_at,
  );
};
